export const appTitle = "React Study Notes";
